var _rect, _circle, _path, _path2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2563eb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    rx: 25,
    fill: "url(#gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 100,
    r: 45,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 70 L340 70",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290 85 L330 85",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 90,
    fontFamily: "Arial",
    fontSize: 36,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "\r\n    ACME\r\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 125,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "white",
    textAnchor: "middle",
    letterSpacing: 2
  }, "\r\n    INNOVATIONS\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyLogo);
export default __webpack_public_path__ + "static/media/dummy-logo.9945f38aaa9dd813e774bd9193b04f8c.svg";
export { ForwardRef as ReactComponent };